import { constructQueryString } from '@/utils/queryBuilderUtils';
import { IMAGES_ON_PAGE } from '../../consts/gallery-const';

export interface GetImagesQueryParams {
  folder_id?: number | null;
  search?: string | null;
  type?: 'Images' | 'PDF' | string | null;
  page?: number | null;
  per_page?: number | null;
  user_id?: number | null;
}

export const getImagesQuery = ({
  folder_id,
  search,
  type,
  page,
  per_page = IMAGES_ON_PAGE,
  user_id,
}: GetImagesQueryParams): string => {
  const queryParams: Record<string, string> = {};

  if (search) queryParams.search = search;
  if (type) queryParams.type = type;
  if (page) queryParams.page = String(page);
  if (per_page) queryParams.per_page = String(per_page);
  if (folder_id) queryParams.folder_id = String(folder_id);
  if (user_id) queryParams.user_id = String(user_id);

  let baseUrl = '/api/gallery';

  const queryString = constructQueryString(queryParams);
  if (queryString) {
    baseUrl += `?${queryString}`;
  }

  return baseUrl;
};